import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import { Button, CircularProgress, Typography } from "@mui/material";
import { Form, Formik } from "formik";
import PlaceholderDetailsForm from "../../molecules/Placeholder/PlaceholderDetailsForm";
import PlaceholderSubForm from "../../molecules/Placeholder/PlaceholderSubForm";
import { useFormWithValidation } from "../../hooks/useFormWithValidation.ts";
import * as Yup from "yup";
import { useSnack } from "../../services/SnakbarProvider.js";
import { handleError } from "../../services/errorHandler.js";

interface PlaceholderFormProps {
  companyId: number;
  onSubmit: () => void;
  id?: number;
}

const initialValues = {
  mainData: {
    providerId: "",
    selectedProvider: null,
    companyId: 0,
  },
};

const validationSchema = Yup.object().shape({
  mainData: Yup.object().shape({
    providerId: Yup.string().required("El proveedor es obligatorio"),
  }),

});

const PlaceholderForm = ({ companyId, onSubmit, id }: PlaceholderFormProps) => {
  const formMode = id ? "edit" : "insert";
  const [formData, setFormData] = useState(initialValues);
  const [loading, setLoading] = useState(false);
  const { openSnack } = useSnack();

  const handleSubmit = async (values) => {
    console.log(values);
  };

  useEffect(() => {
    const fetchData = async () => {
      if (formMode === "edit") {
        // Simulate fetching data
        const mockData = {
          mainData: {
            providerId: "1",
          },
        };
        setFormData(mockData);
      } else {
        setFormData(initialValues);
      }
    };

    fetchData();
  }, [formMode, id, companyId]);

  if (loading) {
    return <CircularProgress />;
  }

  return (
    <Formik
      initialValues={formData}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
      enableReinitialize
    >
      {({ values, errors, touched, setFieldValue }) => (
        <Form id={id?.toString()}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography pb={2} pt={4} variant="h4">
                Datos Principales
              </Typography>
              <PlaceholderDetailsForm />
            </Grid>

            {/* Show selectedProvider object as table */}
            {values?.mainData?.selectedProvider && (
              <Grid item xs={12}>
                <Typography variant="h6" pt={2} pb={1}>
                  Proveedor Seleccionado
                </Typography>
                <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: 16 }}>
                  <tbody>
                    {Object.entries(values.mainData.selectedProvider).map(([key, val]) => (
                      <tr key={key}>
                        <td style={{ border: "1px solid #ddd", padding: 8, fontWeight: 500, background: "#f7f7f7" }}>
                          {key}
                        </td>
                        <td style={{ border: "1px solid #ddd", padding: 8 }}>
                          {typeof val === "object" && val !== null
                            ? JSON.stringify(val)
                            : String(val)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Grid>
            )}

            <Grid item xs={12}>
              <Button 
                variant="contained" 
                color="primary" 
                type="submit" 
                disabled={Object.keys(errors).length > 0}
              >
                Guardar
              </Button>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  );
};

export default PlaceholderForm;
